import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Section } from '../components/Section';
export function Contact() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-215" data-mp="1qpcvc8p6spsy">
      <Navbar data-id="element-216" data-mp="1qoutmwjr9jdn" />
      <main className="flex-grow" data-id="element-217" data-mp="1qna63qvuz0pa">
        {/* Hero Section */}
        <Section className="pt-32 md:pt-48 pb-8 md:pb-12" data-id="element-218" data-mp="1lrl4li0a39qc">
          <div className="max-w-3xl mx-auto text-center" data-id="element-219" data-mp="y0fp53y92jgk">
            <h1 className="font-poppins font-normal text-3xl md:text-5xl text-black leading-tight mb-6" data-id="element-220" data-mp="y0yxbsy3lthe">
              What's hidden matters.
            </h1>
            <p className="font-inter text-base md:text-lg leading-relaxed text-black" data-id="element-221" data-mp="17qqt2qhxosng">
              If something's catching on, or getting stuck, let's talk about it.
            </p>
          </div>
        </Section>
        {/* Direct Contact */}
        <Section className="py-8 md:py-12 pb-24 md:pb-32" data-id="element-222" data-mp="f83dfqlpi5tr">
          <div className="max-w-2xl mx-auto text-center" data-id="element-223" data-mp="aa1vj900ocjv">
            <p className="font-inter text-base md:text-lg text-black" data-id="element-224" data-mp="15ff3zwmjq96n">
              You can reach us directly at{' '}
              <a href="mailto:support@hiddenmatter.ai" className="text-black hover:text-lime transition-colors underline" data-id="element-225" data-mp="19giiaeoy3x5r">
                support@hiddenmatter.ai
              </a>
            </p>
          </div>
        </Section>
      </main>
      <Footer data-id="element-226" data-mp="mgufmcc1hhwp" />
    </div>;
}